import { useStore } from '../use-store';
import { useAuthorizationDialog } from '../use-authorization-dialog';

export function useSquareAuthorization(authDialogOptions, openParams = {}) {
  const store = useStore();

  const { open, isAuthorizing } = useAuthorizationDialog(authDialogOptions);

  function authorize() {
    open({
      provider: 'square',
      params: {
        profile_id: store.getters['profiles/currentProfileId'],
        ...openParams,
      },
    });
  }

  return {
    authorize,
    isAuthorizing,
  };
}
